{
    "global": {
        "TITLE": "Experiencias Educativas",
        "UNIT": "Unidad",
        "FORUM": "Foro",
        "ACTIVITY": "Actividad",
        "COMMENTSWALL": "Intercambio",
        "COMMENT": "Comentar",
        "DISCARD": "Descartar",
        "SAVE": "Guardar",
        "REPLY": "Responder",
        "SHOW_REPLIES": "Ver respuestas",
        "HIDE_REPLIES": "Ocultar respuestas",
        "CANCEL": "Cancelar",
        "RESUME": "Resumen",
        "DETAIL": "Detalle",
        "PARTICIPANTS": "Participantes",
        "TOTAL_DELIVERED": "Total entregados: ",
        "DELIVERY_DATE": "Fecha de entrega: ",
        "ACTIVITY_STATUS": "Estado de la actividad: ",
        "PARTICIPANT": "Participante",
        "STATUS": "Estado",
        "LAST_MODIFICATION": "Última modificación",
        "EXPIRES_IN": "Expira en ",
        "EXPIRED": "Expirado",
        "LATE": "Tarde",
        "NEVER": "Nunca",
        "SAVE_CHANGES": "Guardar cambios",
        "PUBLISH": "Publicar",
        "EMAIL": "Email",
        "DEBATE": "Debate",
        "WITHOUT_ACTIVITY": "Sin actividad",
        "OPEN": "Abierta",
        "OVERDUE": "Vencida",
        "RETURN": "Devolucion",
        "CONFIRM": "Confirmar",
        "STATE": "Estado",
        "CONTINUE": "Continuar",
        "CONTINUE_EDITING": "Continuar editando",
        "OPTIONAL": "Opcional",
        "ERROR_OCCURRED": "Ocurrió un error",
        "DELETE": "Eliminar",
        "FIELD_REQUIRED": "Este campo es requerido",
        "EDIT": "Editar",
        "SEND": "Enviar",
        "BACK": "Volver",
        "YES": "Sí",
        "NO": "No"
    },
    "comments": {
        "COMMENT_HAS_BEEN_REMOVED": "Este comentario ha sido eliminado",
        "WISH_DELETE_COMMENT": "¿Deseas eliminar este comentario?",
        "DELETE_COMMENT": "Borrar comentario",
        "DELETE_THREAD": "Borrar hilo",
        "COMMENT_DELETED": "Comentario eliminado",
        "ERROR_SENDED": "Error al enviar comentario",
        "ERROR_DELETE_COMMENT": "Error al intentar eliminar el comentario",
        "ERROR_EDIT_COMMENT": "Error al editar el comentario",
        "ERROR_LIKE_COMMENT": "Error al likear el comentario",
        "ERROR_EMPTY_COMMENT": "No se puede enviar un comentario vacío"
    },
    "input": {
        "MAX_CHARACTERS": "Máx {maxlength} caracteres",
        "OPTIONAL": "Opcional",
        "PASSWORD_INVALID_CHARACTERS": "La contraseña solo puede contener letras y números"
    },
    "inputDynamicSearch": {
        "PLACEHOLDER": "Escribe al menos 3 letras...",
        "LABEL": "Interlocutor",
        "NO_RESULTS": "No hay resultados"
    },
    "finalPractice": {
        "TEACHER_TITLE": "Guía para el docente",
        "TEACHER_DISCLAIMER": "Recorre paso a paso cómo llevar a cabo la actividad.",
        "STUDENT_TITLE": "Material para el estudiante",
        "STUDENT_DISCLAIMER": "Previsualiza lo que verán tus estudiantes al ingresar al link que les compartas."
    },
    "file": {
        "UPLOAD_FILE": "Subir archivo",
        "MAX_FILE_WEIGHT": "El peso máximo es de 600mb y los formatos permitidos son DOC, DOCX, PPT, PDF, PPTM, PPTX, PDF, PNG, JPG, JPEG, GIF, XLS, XLSX.",
        "uploading":{ 
            "TITLE": "Estamos subiendo tu archivo",
            "MESSAGE": "No cierres ni actualices el navegador."
        },
        "uploading_error":{
            "TITLE": "No pudimos subir el archivo",
            "MESSAGE": "Parece que el achivo que intentas subir no cumple los parámetros. Revisa que no pese más de 600MB y que tenga alguno de los siguientes formatos: PDF, DOC, Excel.",
            "ERROR": "Error al intentar subir archivo"
        },
        "UPLOADED_FILES": "Archivos subidos",
        "emptyState": {
            "TITLE": "Todavía no has subido archivos",
            "MESSAGE": "Sube el archivo desde tu ordenador"

        },
        "DELETE_FILE": "Eliminar archivo"
    },
    "login": {
        "instructions": {
            "FIRST_LOGIN": "Ingresa tu mail y la contraseña que te enviamos para iniciar tu registro",
            "DEFAULT": "Ingresa tu mail y contraseña para ingresar",
            "TERMS_AND_CONDITIONS": "Haciendo click en “Continuar” aceptas los ",
            "RECOVERY_PASSWORD": "Por favor, ingresa primero su email para poder recuperar su contraseña."
        },
        "inputs": {
            "EMAIL": "Email",
            "PASSWORD": "Contraseña"
        },
        "errors": {
            "INCORRECT_USERNAME_OR_PASSWORD": "Usuario o contraseña incorrectos"
        },
        "actions": {
            "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
            "CONTINUE": "Continuar",
            "TERMS_AND_CONDITIONS": "Términos y Condiciones y las Políticas de Privacidad",
            "CANCEL": "Cancelar",
            "PROCESSING": "Procesando"
        },
        "recoveryPassword": {
            "TITLE": "¿Olvidaste tu contraseña?",
            "INSTRUCTION" : "No hay problema, te ayudaremos a crear una nueva. Necesitarás el código de verificación que enviaremos a:"
        }
    },
    "pickrole": {
        "TITLE": "Cambiar el perfil",
        "INSTRUCTION": "Selecciona el perfil con el que quieres ingresar:"
    },
    "nav": {
        "HOME": "Inicio",
        "COURSES": "Cursos",
        "RESOURCES": "Recursos",
        "HELP": "Ayuda",
        "NOTIFICATIONS" : "Notificaciones",
        "PROFILES": "Perfiles",
        "LOG_OUT": "Cerrar sesión",
        "SETTINGS": "Ajustes",
        "PROFILE": "Mi perfil",
        "ERROR": "Ocurrió un error al intentar cambiar de perfil. Intente nuevamente.",
        "CONTENTS": "Contenidos",
        "MANAGEMENT": "Gestión",
        "PROFILE2": "Perfil",
        "EDUCATIVE_EXPERIENCES": "Experiencias Educativas",
        "LEARNING_COMMUNITY": "Learning Community"
    },
    "course": {
        "status": {
            "NotStarted": "No comenzado",
            "InProgress": "En progreso", 
            "Finished" : "Finalizado",
            "COURSE_FINISHED": "Este curso ha finalizado."
        },
        "card":{
            "TUTORS": "Facilitadores",
            "FINISH_DATE": "Finaliza {date}",
            "FINISHED_DATE": "Finalizó {date}",
            "NO_END_DATE": "Sin fecha de finalización",
            "CONTINUE": "Ir al curso",
            "SEE_DETAIL": "Ver detalle",
            "pill": {
                "NOT_FINISHED": "INCOMPLETO",
                "FINISHED": "COMPLETO",
                "true": "CERTIFICADO",
                "false":  "SIN CERTIFICAR"
            }
        },
        "tree": {
            "COURSE_CONTENT": "Contenido del curso",
            "STUDENTSLOG": "Información de tus estudiantes",
            "PRACTICE": "Práctica con tus estudiantes",
            "BOARD": "Muro de Novedades",
            "TUTORIAL": "Ver tutorial"
        },
        "intro":{
            "TITLE": "Introduccion al Programa",
            "END_DATE": "Finaliza ",
            "UNITS": "Unidades",
            "ENDED": "Finalizó",
            "MODULES": "Módulos",
            "CONGRATULATIONS": "¡Felicitaciones! Has completado todas las unidades.",
            "CONGRATULATIONS_REMINDER": "Recuerda que puedes seguir accediendo a los materiales del curso todas las veces que necesites.",
            "ABOUT": "Acerca de este curso",
            "REVIEWS": "Valoraciones",
            "descriptionTitle": "¿Qué vas a aprender en este curso?",
            "courseCharacteristicsTitle": "Características del curso",
            "modality": "Modalidad",
            "duration": "Duración",
            "certification": "Diseñado por Fundación Forge",
            "certificationActivity": "Requiere la realización de una actividad"
        },
        "actions": {
            "CONTINUE_COURSE": "Continuar curso",
            "START_COURSE": "Comenzar curso", 
            "COMPLETED_COURSE": "¡Finalizaste!",
            "RETURN": "Volver",
            "VIEW_REPORT": "Ver reporte",
            "START": "Comenzar"
        },
        "errors": {
            "ERROR_LOADING": "Error al cargar el curso"
        },
        "modules": {
            "muro": {
                "TITLE": "Espacio de intercambio"
            },
            "board": {
                "TITLE": "Muro de novedades"
            },
            "forum": {
                "TITLE": "Foro"
            }
        },
        "courseTypes": {
            "REGULAR": "Regular",
            "ON_DEMAND": "On Demand",
            "0": "Regular",
            "1": "On Demand"
        },
        "targetTypes": {
            "DOCENTE": "Docente",
            "JOVEN": "Joven",
            "0": "Docente",
            "1": "Joven"
        }
    },
    "date" : {
        "PLACEHOLDER": "dd/mm/aaaa",
        "params": {
            "second": "segundo",
            "seconds": "segundos",
            "minute": "minuto",
            "minutes": "minutos",
            "hour": "hora",
            "hours": "horas",
            "day": "día",
            "days": "días",
            "week": "semana",
            "weeks": "semanas"
        }
    },
    "module": {
        "resume": {
            "MANDATORY_ACTIVITY_FINISHED": "Actividades obligatorias completadas",
            "OPTATIVE_ACTIVITY_FINISHED": "Actividades opcionales completadas",
            "TOTAL_STUDENTS": "estudiantes totales",
            "FINISHED_STUDENTS": "estudiantes finalizaron",
            "STARTED_STUDENTS": "estudiantes comenzaron",
            "NOT_STARTED_STUDENTS": "estudiantes no comenzaron"
        },
        "status": {
            "COMING_SOON": "Próximamente",
            "IN_PROGRESS": "En curso",
            "AVAILABLE": "Disponible"
        },
        "actions": {
            "BACK_TO_COURSE_START": "Volver al inicio del curso",
            "PREVIOUS": "Anterior",
            "NEXT": "Siguiente"
        },
        "activities": {
            "statuses":{
                "CONTENT_PENDING_MANDATORY": "Esta actividad es obligatoria",
                "CONTENT_PENDING_OPTATIVE": "Esta actividad es opcional",
                "CONTENT_PENDING_OUT_TIME": "Recuerda que aún tienes esta actividad por completar",
                "CONTENT_FINISHED_IN_TIME": "¡Felicitaciones! Has completado esta actividad",
                "CONTENT_FINISHED_OUT_TIME": "¡Muy bien! Ya estas al día con esta actividad"
            }
        }
    },
    "tutor": {
        "detail": {
            "status": {
                "All": "Todos",
                "FinishedInTime": "Entregado",
                "FinishedOutOfTime": "Entregado fuera de término",
                "NotFinished": "No entregado"
            }
        },
        "report":{
            "userSituation": {
                "END_NONE_CONTENT": "No finalizaron ningún contenido",
                "END_SOME_CONTENT": "Finalizaron algún contenido",
                "END_ALL_CONTENT": "Finalizaron todos los contenidos a la fecha"
            },
            "activityStatus": {
                "FinishedInTime": "Entregado",
                "FinishedOutOfTime": "Entregado fuera de termino",
                "NotFinished": "No entregado"
            }
        }
    },
    "role": {
        "LEARNINGUSER": "Estudiante",
        "TUTOR": "Facilitador",
        "GESTOR_PLATAFORMA": "Gestor de plataforma",
        "COORDINADOR_PEDAGOGICO": "Coordinador pedagógico",
        "EDITOR_CONTENIDO": "Editor de contenido",
        "COORDINADOR_ACADEMICO": "Coordinador académico",
        "ADMINISTRADOR": "Administrador"
    },
    "preInscription": {
        "error": {
            "EMAIL_IS_MANDATORY": "Es necesario el e-mail para continuar con el proceso",
            "PREINSCRIPTION_NOT_FOUND": "La preinscripción a la que intentas acceder no existe",
            "PREINSCRIPTION_IS_FULL": "La preinscripción a la que intentas acceder está completa",
            "PREINSCRIPTION_TIMED_OUT": "La preinscripción a la que intentas acceder ha finalizado",
            "PREINSCRIPTION_IS_NOT_PUBLISHED": "La inscripción no está disponible.",
            "NAMES_ARE_MANDATORY": "Los campos ‘Nombre' y 'Apellido’ son obligatorios ",
            "STAGE_ONE_NOT_FOUND": "No puedes acceder a la segunda etapa de la preinscripción sin haber completado la primera",
            "STAGE_ALREADY_COMPLETED": "Ya has completado previamente esta etapa de la preinscripción",
            "An error has ocurred": "Ha ocurrido un error.",
            "INVALID_CAPTCHA": "El captcha es inválido"
        },
        "status": {
            "OPEN": "Abierto",
            "CLOSED": "Cerrado",
            "EXPIRED": "Cerrado",
            "CLOSED_COURSE_CREATION" : "Cerrado",
            "FULL": "Completo",
            "PENDING_OPEN": "Pendiente"
        },
        "preInscriptionTypes": {
            "REGULAR": "Regular",
            "ON_DEMAND":"On Demand"
        },
        "statusPlural": {
            "OPEN": "Abiertos",
            "CLOSED": "Cerrados",
            "FULL": "Completos",
            "PENDING_OPEN": "Pendientes de apertura",
            "ALL": "Todos"
        },
        "fields": {
            "FIRSTNAME": "Nombre",
            "LASTNAME": "Apellido",
            "EMAIL": "Email",
            "GENDER": "Género",
            "COUNTRY": "País",
            "PHONE": "Teléfono",
            "BIRTHDATE": "Fecha de nacimiento",
            "DNI": "DNI",
            "SCHOOLNAME": "Inst. educativa / Plantel",
            "PREFIX": "Prefijo",
            "STUDENTSQUANTITY_bkp": "Cantidad de alumnos por año",
            "STUDENTSQUANTITY": "En el último año ¿con cuántos estudiantes has trabajado?"
        }
            
    },
    "courseInstance": {
        "status": {
            "InProgress": "En progreso",
            "Finished": "Terminado",
            "NotStarted": "Sin iniciar"
        },
        "courseTypes":{
            "REGULAR":"Regular",
            "ON_DEMAND":"On Demand"
        }
    },
    "home": {
        "TITLE": "Te damos la bienvenida a ",
        "COURSES": "Tus cursos",
        "RESOURCES": "Recursos destacados"
    },
    "myCourses": {
        "TITLE" : "Programas en curso"
    },
    "resources": {
        "filters": {
            "TOPIC": "Temática",
            "CATEGORY": "Categoría" 
        },
        "titles": {
            "LAST_RESOURCES_VIEWED": "Últimos recursos vistos",
            "HIGHLIGHTED_RESOURCES": "Recursos destacados",
            "NEW_RESOURCES": "Nuevos recursos",
            "FILTERED_RESOURCES": "Recursos filtrados"
        }
    },
    "forum":{
        "actions": {
            "BACK_TO_MODULE": "Volver al módulo",
            "LIKE": "Me gusta",
            "REPLY": "Responder",
            "NEW_DISCUSSION": "+ Nuevo debate"
        },
        "DELIVERY_DATE": "Fecha de entrega: ",
        "CORRECT_NEW_DISCUSSION": "Creaste un nuevo tema de debate",
        "instructions": {
            "COURSE_FINISHED": "Podrás seguir viendo todos los comentarios del foro aunque ya no es posible participar."
        },
        "errors": {
            "LIKE_HEADER": "Error al likear header",
            "INVALID_TITLE": "Debe ingresar un título válido.",
            "ERROR_POST_NEW_DISCUSSION": "Error al publicar tema de debate",
            "EDIT_HEADER": "Error al editar tema de debate",
            "LOAD_RESUME": "Ocurrió un error al cargar el resumen",
            "LOAD_DETAIL": "Ocurrió un error al cargar el detalle"
        },
        "tutorView": {
            "TITLE": "Temas de debate",
            "TOPIC_OF_DISCUSSION": "Tema de debate",
            "CREATED_BY": "Creado por",
            "LAST_ANSWER": "Última respuesta",
            "NUMBER_OF_RESPONSES": "Cantidad de respuestas"
        },
        "emptyState": {
            "TITLE": "Todavía no hay temas de debate",
            "TUTOR_MESSAGE": "Recuerda abrir el tema de debate para que tu grupo pueda participar del foro.",
            "MESSAGE": "En breve tu facilitador inaugurará el foro para que puedas participar."
        },
        "history": {
            "DETAIL_TITLE": "Detalle de entrega",
            "COMMENT_HISTORY": "Historial de comentarios"
        }
    },
    "activity": {
        "LOAD_CONTENT": "Cargando contenido ...",
        "LAST_RETURN": "Última devolución de tu entrega",
        "status": {
            "done":{
                "TITLE": "Esta actividad se encuentra entregada.",
                "INFO": "Si deseas modificar tu entrega puedes subir más archivos o eliminar los que ya has subido."
            },
            "pending": {
                "TITLE": "Esta actividad se encuentra pendiente.",
                "INFO": "Sube archivos desde tu ordenador. Recuerda que el peso máximo es de 600MB y los formatos permitidos son DOC, DOCX, PPT, PDF, PPTM, PPTX, PDF, PNG, JPG, JPEG, GIF, XLS, XLSX."
            },
            "finished":{
                "TITLE": "Este curso ha finalizado",
                "INFO": "Ya no es posible modificar tu entrega."
            }
        },
        "CONFIRM_DELIVERY": "Confirmar entrega",
        "CONTINUE_EDITING": "Continuar editando",
        "DISCARD_CHANGES": "Descartar cambios",
        "DELETE_DELIVERY": "Eliminar entrega",
        "sendActivity": {
            "TITLE": "¡Muy bien!<br>Estás a un paso de finalizar esta actividad.",
            "INFO": "Confirmando tu entrega, tu actividad quedará registrada como finalizada.<br>Recuerda que podrás seguir agregando archivos o editar los que ya subiste."
        },
        "confirmChanges": {
            "TITLE": "¿Deseas guardar los cambios?",
            "INFO": "Has editado los archivos de tu entrega. Confirma si deseas que consideremos estos archivos para la entrega de tu actividad."
        },
        "discardChanges": {
            "TITLE": "¿Cancelar edición?",
            "INFO": "Si cancelas la edición, los cambios que hayas hecho a tu entrega no se guardarán."
        },
        "deleteActivity": {
            "TITLE": "¿Deseas eliminar tu entrega?",
            "INFO": "Ten en cuenta que si eliminas todos los archivos, tu entrega quedará marcada nuevamente como no entregada."
        },
        "fileUploading": {
            "TITLE": "Estamos subiendo tu archivo",
            "INFO": "No cierres ni actualices el navegador."
        },
        "removeFile": {
            "TITLE": "¿Estás seguro que deseas eliminar este archivo?",
            "INFO": "Luego de guardar los cambios, el archivo ya no formará parte de tu entrega"
        },
        "errorFile": {
            "TITLE": "No pudimos subir el archivo",
            "INFO": "Parece que el achivo que intentas subir no cumple los parámetros.<br>Revisa que no pese más de 600 MB y que tenga alguno de los siguientes formatos: PDF, DOC, Excel."
        },
        "feedback":{
            "SENT_CORRECTLY": "Feedback enviado correctamente",
            "ERROR": "Error al enviar feedback"
        },
        "ERROR_CONFIRM": "Error al confirmar la entrega. Tus cambios no se guardaron",
        "ERROR_DELETE_FILE": "Error al intentar eliminar archivo",
        "ERROR_GET_FILES": "Ocurrió un error al intentar obtener tus archivos",
        "ERROR_LOAD_SUMMARY": "Ocurrió un error al cargar el resumen",
        "ERROR_LOAD_DETAIL": "Ocurrió un error al cargar el detalle"
    },
    "management": {
        "course":{
            "Active": "En progreso",
            "Inactive": "Baja",
            "Finished": "Terminado",
            "Reactivated": "En progreso",
            "certificate": "Certificó",
            "All": "Todos"
        }
    },
    "contents": {
        "mastercourses": {
            "PUBLISHED": "Publicado",
            "DRAFT": "Borrador",
            "DISABLED": "Deshabilitado"
        }
    },
    "certificate": {
        "TITLE": "CERTIFICADO",
        "NEW_CERTIFICATE": "Nuevo certificado",
        "PREVIEW": "PREVISUALIZACIÓN",
        "ERROR_OCCURRED": "Ha ocurrido un error, por favor intente de nuevo más tarde.",
        "NAME": "NOMBRE",
        "ENTER_NAME": "Ingresa un nombre para el nuevo certificado:",
        "NAME_PLACEHOLDER": "Ejemplo: MEX-TMT-23-01",
        "NAME_LABEL": "Nombre del certificado",
        "EXISTING_NAME_ERROR": "Ya existe un certificado con ese nombre, por favor regresa al selector de certificados para seleccionarlo",
        "STYLE": "ESTILO",
        "CHOOSE_STYLE": "Elige un estilo para el nuevo certificado:",
        "DESIGN": "DISEÑO",
        "CHOOSE_DESIGN": "Elige una imagen para el diseño del nuevo certificado:",
        "UPLOAD_IMAGE": "Subir imagen",
        "UPLOADING_FILE": "Subiendo archivo",
        "IMAGE_REQUIREMENTS": "Formato: PNG. Tamaño mínimo: {width}x{height} px",
        "PREVIEW_INFO": "Aquí podrás previsualizar el certificado que estás creando.",
        "CONFIRM_CANCEL_TITLE": "¿Deseas <strong>cancelar</strong> este nuevo certificado?",
        "CONFIRM_CANCEL_TEXT": "Se perderán toda la información que has cargado. Esta acción no se puede deshacer.",
        "NO_GO_BACK": "No, volver",
        "YES_CANCEL": "Sí, cancelar",
        "YES": "Sí",
        "NO": "No"
    },
    "detailData": {
        "PARTICIPANT": "Participante",
        "STATUS": "Estado",
        "LAST_MODIFICATION": "Última modificación"
    },
    "emptyState": {
        "SEARCH_NO_RESULTS": "No encontramos ningún resultado para <strong>\"{query}\"</strong>. Intenta con otra palabra.",
        "UPLOAD_FILE": "Subir un archivo"
    },
    "helpMenu": {
        "HELP": "Ayuda",
        "CONTACT_US": "Contáctanos",
        "VIEW_TUTORIAL": "Ver tutorial"

    },
    "helpModal": {
        "NEED_HELP": "¿Necesitas ayuda?",
        "SEND_US_YOUR_QUERY": "Envíanos tu consulta al <span class=\"phone-number\">2266 446599</span> y en breve nos pondremos en contacto para ayudarte.",
        "WRITE_YOUR_QUERY": "Escribe tu consulta...",
        "SEND": "Enviar",
        "THANK_YOU": "Gracias por tu mensaje",
        "RECEIVED_SUCCESSFULLY": "Recibimos tu consulta con éxito",
        "WILL_CONTACT_SOON": "Nos pondremos en contacto a la brevedad",
        "ERROR_OCCURRED": "Ha ocurrido un error",
        "PLEASE_TRY_AGAIN_LATER": "Por favor, intenta de nuevo más tarde"
    },
    "linkPreview": {
        "ADD_LINK": "Agregar link",
        "LINK_PLACEHOLDER": "Link"
    },
    "onboardingModal": {
        "WELCOME": "Te damos la bienvenida",
        "LOAD_ERROR": "Ocurrió un error al cargar el tutorial"
    },
    "studentsTable": {
        "MANAGE_PARTICIPANTS": "Gestionar participantes",
        "CERTIFIED": "Certificado",
        "NOT_CERTIFIED": "No certificado",
        "ALL_CERTIFICATES": "Todos los certificados",
        "STATUS": "Estado",
        "SEARCH_PLACEHOLDER": "Buscar...",
        "COURSE": "Curso",
        "ADD_NEW_PARTICIPANT": "Agregar nuevo participante",
        "PARTICIPANT": "Participante",
        "MAIL": "Correo electrónico",
        "PHONE": "Teléfono",
        "LAST_ACCESS": "Último acceso",
        "LAST_INTERACTION": "Última interacción",
        "YES": "Sí",
        "NO": "No",
        "CERTIFICATION_FORCED_TOOLTIP": "Certificación forzada por {email} el {date}",
        "UNSUBSCRIBE": "Dar de baja",
        "SUBSCRIBE": "Dar de alta",
        "FORCE_CERTIFICATION": "Forzar certificación",
        "UNDO_CERTIFICATION": "Deshacer certificación",
        "CHANGE_EMAIL": "Cambiar email",
        "CHANGE_PHONE": "Cambiar teléfono",
        "VIEW_INTERACTIONS": "Ver interacciones",
        "ADD_NEW_INTERACTION": "Agregar nueva interacción",
        "CHANGE_PARTICIPANT_EMAIL": "Cambiar email del participante",
        "ENTER_NEW_EMAIL": "Ingresa el nuevo email",
        "EMAIL": "Email",
        "INVALID_EMAIL_FORMAT": "Formato de email inválido",
        "BACK": "Atrás",
        "CONTINUE": "Continuar",
        "CHANGE_PARTICIPANT_PHONE": "Cambiar teléfono del participante",
        "CURRENT_PHONE": "Teléfono actual",
        "ENTER_NEW_PHONE": "Ingresa el nuevo teléfono",
        "FORCE_CERTIFICATION_PROMPT": "¿Deseas forzar la certificación de",
        "CANCEL": "Cancelar",
        "UNDO_CERTIFICATION_PROMPT": "¿Deseas deshacer la certificación de",
        "NO_RESULTS": "No hay resultados",
        "UNSUBSCRIBE_USER": "Dar de baja al usuario",
        "PROCEED_UNSUBSCRIBE": "Procederemos a la baja de {count} participantes",
        "DECISION": "Decisión",
        "FORGE": "Forge",
        "ON_PARTICIPANT_REQUEST": "A pedido del participante",
        "REASON_FOR_UNSUBSCRIBE": "Motivo de baja",
        "LACK_OF_INTEREST": "Falta de interés en la temática",
        "PLATFORM_ISSUES": "Problemas con la plataforma",
        "NO_TIME_AVAILABLE": "No dispone de tiempo",
        "OTHERS": "Otros",
        "SPECIFY_REASON": "Especificar motivo",
        "MOVE_PARTICIPANTS": "Mover participantes",
        "SELECT_NEW_COURSE": "Seleccione el nuevo curso",
        "ENTER_NEW_PARTICIPANT_EMAIL": "Ingresa el email del nuevo participante",
        "REQUIRED_FIELDS_FOR_PARTICIPANT": "Te pedimos los siguientes datos para dar de alta este participante:",
        "NOTIFICATION_PARTICIPANT_ADDED": "Participante agregado exitosamente",
        "NOTIFICATION_USER_EXISTS": "El usuario ya existe",
        "NOTIFICATION_ADD_PARTICIPANT_ERROR": "Error al agregar el participante",
        "NOTIFICATION_EMAIL_CHANGED": "Email cambiado correctamente",
        "NOTIFICATION_EMAIL_EXISTS": "El email ingresado ya existe",
        "NOTIFICATION_ERROR": "Ha ocurrido un error. Inténtalo más tarde",
        "NOTIFICATION_PHONE_CHANGED": "Teléfono modificado correctamente",
        "NOTIFICATION_ERROR_CHANGING_PHONE": "Error al modificar el teléfono",
        "NOTIFICATION_CERTIFICATION_FORCED": "Certificación forzada correctamente",
        "NOTIFICATION_CERTIFICATION_ERROR": "Ocurrió un error durante la certificación",
        "NOTIFICATION_CERTIFICATION_UNDONE": "Certificación deshecha correctamente",
        "NOTIFICATION_UNCERTIFICATION_ERROR": "Ocurrió un error durante la descertificación",
        "NOTIFICATION_ALTER_STATE_ERROR": "Ocurrió un error al alterar el estado del usuario",
        "NOTIFICATION_ERROR_LOADING_FILTERS": "Error al cargar opciones de filtros",
        "NOTIFICATION_ERROR_FETCHING_DATA": "Error al obtener los datos",
        "NOTIFICATION_ERROR_DOWNLOADING_FILE": "Error al descargar archivo",
        "NOTIFICATION_ERROR_CHANGING_STATUS": "Error al intentar cambiar el estado",
        "PREVIOUS": "Anterior",
        "NEXT": "Siguiente",
        "FIRST_NAME": "Nombre",
        "LAST_NAME": "Apellido",
        "COUNTRY": "País"
  },
  "uploadFileDrag": {
    "DRAG_DROP_OR_CLICK": "Puedes arrastrar tu archivo aquí o bien",
    "UPLOAD_FILE": "Subir un archivo",
    "UPLOADING_FILE": "Subiendo archivo...",
    "UPLOADED_FILES": "Archivos subidos",
    "ONE_FILE_UPLOADED": "1 archivo subido"
  },
  "attach": {
    "BACK_TO_MODULE": "Volver al módulo",
    "CONTENT_NOT_AVAILABLE": "Este contenido no se encuentra disponible aún",
    "CONTENT_AVAILABLE_MESSAGE": "<span>Podrás visualizarlo a partir del <strong>{date}</strong><br>Si quieres ver más material, te invitamos a que recorras los distintos artículos, podcast y charlas que hemos seleccionado para ti en la sección <a href='/resources' style='color:#9E5498;font-weight:600;'>Recursos</a></span>",
    "MANDATORY_ACTIVITY": "Actividad obligatoria",
    "OPTIONAL_ACTIVITY": "Actividad optativa",
    "UPLOAD_A_FILE": "Subir un archivo",
    "UPLOAD_ANOTHER_FILE": "Subir otro archivo",
    "WRITE_AN_ANSWER": "Escribe una respuesta...",
    "REMAINING_CHARACTERS": "{count} caracteres restantes",
    "VIEW_FEEDBACK_HISTORY": "Ver historial de feedbacks",
    "STUDENTS_QTY_TITLE": "Cantidad de jóvenes con quienes aplicaste la práctica",
    "STUDENTS_QTY_INFO": "Por favor, ingresa la cantidad de jóvenes con quienes aplicaste la práctica.",
    "STUDENTS_QTY": "Cantidad de jóvenes",
    "CONFIRM_SEND_FEEDBACK": "¿Enviar devolución a {count} estudiante/s?",
    "SENT": "Enviada",
    "NOT_SENT": "Sin enviar",
    "STUDENTS_QTY_UPDATED_SUCCESS": "Cantidad de jóvenes con quienes aplicaste la práctica actualizada correctamente",
    "STUDENTS_QTY_UPDATED_ERROR": "Error al actualizar la cantidad de jóvenes con quienes aplicaste la práctica"
  },
  "attachUserHistory": {
    "BACK": "Volver",
    "DELIVERY_DETAIL": "Detalle de la entrega",
    "ACTIVITY_STATUS": "Estado de la actividad",
    "OPEN": "Abierta",
    "EXPIRED": "Vencida",
    "LAST_MODIFICATION": "Última modificación",
    "FILES": "Archivos",
    "DELIVERIES_HISTORY": "Historial de entregas",
    "HAS_MADE_A_NEW_DELIVERY": "ha realizado una nueva entrega",
    "NO_FILES_UPLOADED_TITLE": "Todavía no hay archivos subidos",
    "NO_FILES_UPLOADED_MESSAGE": "Anima a que participe en esta actividad con un mensaje de aliento.",
    "YOUR_FEEDBACK": "Tu devolución",
    "LOADING_INFORMATION": "Cargando información"
  },
  "moduleMuro": {
    "BACK_TO_MODULE": "Volver al módulo",
    "CONTENT_NOT_AVAILABLE": "Este contenido no se encuentra disponible aún",
    "CONTENT_AVAILABLE_MESSAGE": "<span>Podrás visualizarlo a partir del <strong>{date}</strong><br>Si quieres ver más material, te invitamos a que recorras los distintos artículos, podcast y charlas que hemos seleccionado para ti en la sección <a href='/resources' style='color:#9E5498;font-weight:600;'>Recursos</a></span>",
    "MANDATORY_ACTIVITY": "Actividad obligatoria",
    "OPTIONAL_ACTIVITY": "Actividad optativa",
    "SWIPE_LEFT_TO_SEE_TOPICS": "Desliza hacia la izquierda para ver todos los temas",
    "ADD_REFLECTION": "Agregar reflexión",
    "COMMENT_DELETED": "Este comentario ha sido eliminado.",
    "LIKE": "Me gusta",
    "REPLY": "Responder",
    "HIDE": "Ocultar",
    "SHOW": "Ver",
    "RESPONSES": "respuestas",
    "SEE_MORE": "Ver más",
    "OPEN": "Abierta",
    "EXPIRED": "Vencida",
    "ERROR_LOADING_INFORMATION": "Ha ocurrido un problema cargando la información. Inténtelo más tarde.",
    "ERROR_PERFORMING_ACTION": "Ha ocurrido un error al intentar realizar la acción.",
    "COMMENT_CANNOT_BE_EMPTY": "El comentario no puede estar vacío.",
    "ERROR_SENDING_COMMENT": "Ha ocurrido un error enviando el comentario.",
    "ERROR_LOADING_COMMENTS": "Ocurrió un error cargando comentarios.",
    "ERROR_DELETING_COMMENT": "Ha ocurrido un error eliminando el comentario.",
    "ERROR_EDITING_COMMENT": "Ha ocurrido un error editando el comentario."
  },
  "muroUserHistory": {
    "BACK": "Volver",
    "DELIVERY_DETAIL": "Detalle de la entrega",
    "NO_COMMENTS": "No hay comentarios",
    "USER_HAS_NOT_POSTED_COMMENTS": "El usuario aún no ha publicado comentarios",
    "LOADING_INFORMATION": "Cargando información"
  },
  "commentsWall": {
    "instructions": {
        "COURSE_FINISHED": "Podrás seguir viendo todos los comentarios del espacio de intercambio aunque ya no es posible participar."
    },
    "CREATE_EXCHANGE_ACTIVITY": "Crear actividad de intercambio",
    "EDIT_EXCHANGE_ACTIVITY": "Editar actividad de intercambio",
    "STEP_OF": "Paso {step} de {total}",
    "COURSE_SCREEN": "Pantalla del curso",
    "FORUM_SCREEN": "Pantalla del foro",
    "ACTIVITY_SCREEN": "Pantalla de la actividad",
    "STATEMENT": "Enunciado",
    "PEDAGOGICAL_CONTENT": "Contenido pedagógico",
    "LINK": "Link",
    "LINK_SUPPORT_TEXT": "Deberás seleccionar el link de carácter exclusivo de la solapa Enlace",
    "INSTRUCTION": "Consigna",
    "MARK_AS_MANDATORY_ACTIVITY": "Marcar como actividad obligatoria",
    "EXCHANGE_SPACE_CONFIGURATION": "Configuración del espacio de intercambio",
    "NUMBER_OF_TOPICS": "Cantidad de temas",
    "ERROR_EDITING_TOPIC": "Error al intentar editar el Tema {number}",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "contentShare": {
    "EDIT_PRACTICE_WITH_STUDENTS": "Editar práctica con estudiantes",
    "ACTIVITY": "Actividad",
    "ACTIVITY_COVER": "Portada de la actividad",
    "HIDE_STUDENT_TAB": "Ocultar pestaña de estudiantes",
    "LINK": "Link",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "createContent": {
    "NEED_TO_ADD_MORE_CONTENT": "¿Necesitas agregar más contenido?",
    "STATEMENT": "Enunciado",
    "CONTENT": "Contenido",
    "ACTIVITY": "Actividad",
    "FORUM": "Foro",
    "EXCHANGE": "Intercambio",
    "DIVIDER": "Divisor",
    "IMAGE": "Imagen"
  },
  "forumActivity": {
    "CREATE": "Crear",
    "EDIT": "Editar",
    "FORUM": "foro",
    "ACTIVITY_TO_DELIVER": "actividad para entregar",
    "MARK_AS_MANDATORY_ACTIVITY": "Marcar como actividad obligatoria",
    "COURSE_SCREEN": "Pantalla del curso",
    "ACTIVITY_SCREEN": "Pantalla de la {type}",
    "ACTIVITY": "actividad",
    "STATEMENT": "Enunciado",
    "PEDAGOGICAL_CONTENT": "Contenido pedagógico",
    "CONTENT_TYPE": "Tipo de contenido",
    "REQUIRED_FIELD": "Campo requerido",
    "LINK": "Link",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "genially": {
    "CREATE_PEDAGOGICAL_CONTENT": "Crear contenido pedagógico",
    "EDIT_PEDAGOGICAL_CONTENT": "Editar contenido pedagógico",
    "CONTENT_TYPE": "Tipo de contenido",
    "LINK": "Link",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
    },
  "html": {
    "CREATE_STATEMENT": "Crear enunciado",
    "EDIT_STATEMENT": "Editar enunciado",
    "STATEMENT_TYPE": "Tipo de enunciado",
    "WELCOME": "Bienvenida",
    "MATERIAL_TO_WATCH": "Material para observar",
    "MATERIAL_TO_READ": "Material para leer",
    "MATERIAL_TO_INTERACT": "Material para interactuar",
    "END_OF_MODULE": "Fin de módulo",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "image": {
    "ADD_IMAGE_BLOCK": "Agregar bloque de imagen",
    "EDIT_IMAGE_BLOCK": "Editar bloque de imagen",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "portada": {
    "MODULE_CONFIGURATION": "Configuración del módulo",
    "MODULE_COVER": "Portada del módulo",
    "DIMENSIONS_HINT": "Medidas 1600px x 186px - 2 MB",
    "ERROR_CONFIGURING_COVER": "Error al configurar portada"
  },
  "trip": {
    "EDIT_PRACTICE_WITH_STUDENTS": "Editar práctica con estudiantes",
    "ERROR_SAVING_CONTENT": "Error al intentar guardar contenido"
  },
  "certificateComponent": {
    "CREATE_COPY_OF_MASTER_COURSE": "Crear copia de Curso Maestro",
    "STEP_NUMBER": "PASO {number}",
    "CERTIFICATION": "Certificación",
    "ON_DEMAND_COURSES_NO_CERTIFICATION": "Los cursos On Demand no poseen certificación.",
    "CONDITIONS_TO_CERTIFY": "CONDICIONES PARA CERTIFICAR",
    "PERCENTAGE_OF_MANDATORY_ACTIVITIES_SUBMITTED": "Porcentaje de actividades obligatorias entregadas",
    "PRACTICE_WITH_YOUR_STUDENTS": "Práctica con tus estudiantes",
    "PROGRAM_NAME": "Nombre del programa",
    "THIS_FIELD_IS_REQUIRED": "Este campo es requerido",
    "SUBTITLE": "Bajada",
    "HOUR_TYPE": "Tipo de horas",
    "DURATION_IN_HOURS": "Duración en {hourType}",
    "HOURS": "horas",
    "PERCENTAGE": "Porcentaje",
    "ERROR_SENDING_INFORMATION": "Ocurrió un error enviando la información."
  },
  "configurationMasterCourses": {
    "MAKE_COPY_OF_MASTER_COURSE": "Hacer una copia <br/> de Curso Maestro",
    "STEP_NUMBER": "PASO {number}",
    "GENERAL_CONFIGURATION": "Configuración general",
    "INTERNAL_NAME": "Nombre interno",
    "INTERNAL_NAME_SUPPORT_TEXT": "Es el nombre para identificar el curso internamente",
    "FIELD_REQUIRED": "Este campo es requerido",
    "COURSE_COVER": "PORTADA DEL CURSO",
    "UPLOAD_A_FILE": "Subir un archivo",
    "FILE_DIMENSIONS_HINT": "Medidas 4000px x 2250px - 2 MB",
    "UPLOADED_FILES": "Archivos subidos",
    "ONE_FILE_UPLOADED": "1 archivo subido",
    "SHORT_NAME": "Nombre corto",
    "SHORT_NAME_SUPPORT_TEXT": "Es el nombre que verán los participantes en la plataforma",
    "COURSE_TYPE": "Tipo de curso",
    "TARGET_TYPE": "Público",
    "EXIT_EDITING_TITLE": "¿Deseas salir de la edición del curso?",
    "EXIT_EDITING_CONTENT": "Los cambios que hayas realizado no quedarán guardados.",
    "EXIT_EDITING_BUTTON": "Salir de la edición",
    "ERROR_CONTINUING": "Ha ocurrido un error al continuar."
  },
  "courseStructure": {
    "MAKE_COPY_OF_MASTER_COURSE": "Hacer una copia <br /> de Curso Maestro",
    "STEP_NUMBER": "PASO {number}",
    "COURSE_STRUCTURE": "Estructura del curso",
    "CONTENTS": "Contenidos",
    "ADD_UNIT": "Agregar unidad",
    "UNIT_NAME": "Nombre de la unidad",
    "EDIT_TITLE": "Editar título",
    "ADD_MODULE": "Agregar módulo",
    "DELETE_UNIT": "Eliminar unidad",
    "EDIT_UNIT_NAME": "Editar nombre de la unidad",
    "CONFIRM_DELETE_UNIT": "¿Deseas eliminar la unidad <strong>{unitName}</strong>?",
    "DELETE_UNIT_WARNING": "Una vez eliminada, no se podrá recuperar su contenido.",
    "DELETE_UNIT_BUTTON": "Eliminar unidad",
    "ADD_NEW_MODULE": "Agregar nuevo módulo",
    "MODULE_NAME": "Nombre del módulo",
    "MODULE_NAME_REQUIRED": "El nombre del módulo es requerido",
    "MODULE": "MÓDULO",
    "PUBLICATION": "PUBLICACIÓN",
    "PUBLICATION_TOOLTIP": "Es el intervalo de días con el que se irán publicando los contenidos, considerando los días desde el inicio del curso.",
    "UNIT_HAS_NO_CONTENT": "Esta unidad no tiene contenido.",
    "EDIT_CONTENT": "Editar contenido",
    "EDIT_CONFIGURATION": "Editar configuración",
    "MODULE_CONFIGURATION": "Configuración del módulo",
    "PUBLICATION_INTERVAL_DAYS": "Intervalo de publicación (días)",
    "PUBLICATION_INTERVAL_SUPPORT_TEXT": "Es la cantidad de días (desde el inicio del curso) que tienen que pasar para que abra el módulo.",
    "CONFIRM_DELETE_MODULE": "¿Deseas eliminar el módulo <strong>{moduleName}</strong>?",
    "DELETE_MODULE_WARNING": "Una vez eliminado, no se podrá recuperar su contenido.",
    "DELETE_MODULE_BUTTON": "Eliminar módulo",
    "PRACTICE_WITH_STUDENTS": "Práctica con estudiantes",
    "ON_DEMAND_NO_PRACTICE": "Los cursos On Demand no poseen práctica con estudiantes",
    "TYPE": "TIPO",
    "NO_PRACTICE_ASSOCIATED": "Este curso no tiene una práctica con estudiantes asociada.",
    "ERROR_ADDING_MODULE": "Ha ocurrido un error agregando el nuevo módulo",
    "EMPTY_NAME_ERROR": "No se puede modificar a un nombre vacío",
    "UNIT_NAME_UPDATED": "Nombre de unidad actualizado",
    "ERROR_UPDATING_UNIT_NAME": "Error al actualizar el nombre de la unidad",
    "MODULE_NAME_UPDATED": "Nombre de módulo actualizado",
    "ERROR_UPDATING_MODULE_NAME": "Error al actualizar el nombre del módulo",
    "ERROR_SAVING": "Error al guardar",
    "TRIP": "Trip",
    "CONTENT_SHARE": "Práctica situada",
    "COURSE_START": "Inicio del curso",
    "DAYS_INTERVAL": "{days} Días",
    "WEEKS_INTERVAL": "{weeks} Semanas"
  },
  "disclaimer": {
    "EDITING_PUBLISHED_COURSE": "Estás editando un curso maestro publicado",
    "ONLY_SOME_FIELDS_EDITABLE": "En esta instancia, solo algunos campos pueden editarse.",
    "MODIFICATIONS_WILL_IMPACT_ASSOCIATED_COURSES": "Toda modificación que realices impactará en los cursos asociados a este curso maestro."
  },
  "informationMasterCourses": {
    "CONFIGURATION": "Configuración",
    "STEP_NUMBER": "PASO {number}",
    "COURSE_INFORMATION": "Información de la cursada",
    "COURSE_DESCRIPTION": "DESCRIPCIÓN DEL CURSO",
    "COURSE_DESCRIPTION_PLACEHOLDER": "En este curso aprenderás...",
    "MODALITY": "Modalidad",
    "TOTAL_DURATION_WEEKS": "Duración total (semanas)",
    "WEEKS": "semanas",
    "WEEKLY_HOURS_DEDICATION": "Dedicación horaria semanal",
    "HOURS": "horas",
    "TUTORIAL": "Tutorial",
    "ERROR_SENDING_DATA": "Ha ocurrido un error al enviar los datos."
  },
  "masterCoursesMain": {
    "GO_BACK_TO_COURSE_STRUCTURE": "Volver a la estructura del curso",
    "GO_BACK_TO_COURSE_LIST": "Volver al listado de cursos",
    "CONFIRM_EXIT_EDITING": "¿Deseas salir de la edición del curso?",
    "CHANGES_WILL_NOT_BE_SAVED": "Los cambios que hayas realizado no quedarán guardados.",
    "EXIT_EDITING": "Salir de la edición",
    "ERROR_LOADING_INFORMATION": "Ocurrió un error cargando la información"
  },
  "review": {
    "CREATE_COPY_OF_MASTER_COURSE": "Crear copia <br /> de Curso Maestro",
    "STEP_NUMBER": "PASO {number}",
    "CHECK_INFORMATION_IS_CORRECT": "Revisa que la información sea correcta",
    "GENERAL_CONFIGURATION": "CONFIGURACIÓN GENERAL",
    "COURSE_INFORMATION": "INFORMACIÓN DEL CURSO",
    "COURSE_STRUCTURE": "ESTRUCTURA DEL CURSO",
    "CERTIFICATION": "CERTIFICACIÓN",
    "SHORT_NAME": "Nombre corto",
    "FULL_NAME": "Nombre completo",
    "COURSE_TYPE": "Tipo de curso",
    "TARGET_AUDIENCE": "Público",
    "MODALITY": "Modalidad",
    "HOUR_DEDICATION": "Dedicación horaria",
    "HOURS_PER_WEEK": "horas semanales",
    "TOTAL_DURATION": "Duración total",
    "WEEKS": "semanas",
    "DESCRIPTION": "Descripción",
    "UNIT": "Unidad",
    "MODULE": "Módulo",
    "PUBLICATION": "Publicación",
    "COURSE_START": "Inicio del curso",
    "WEEKS_INTERVAL": "{weeks} semanas",
    "PRACTICE_WITH_STUDENTS": "Práctica con estudiantes",
    "PRACTICE_TYPE": "Tipo de práctica",
    "SITUATED_PRACTICE": "Práctica Situada",
    "CONDITIONS": "Condiciones",
    "MANDATORY_ACTIVITIES_SUBMITTED": "actividades obligatorias entregadas",
    "STUDENT_PRACTICE_SUBMITTED": "Actividad Práctica con estudiantes entregada",
    "PROGRAM_NAME": "Nombre del programa",
    "SUBTITLE": "Bajada",
    "TOTAL_DURATION_IN": "Duración total en {hourType}",
    "SAVE_DRAFT": "Guardar borrador",
    "MODIFY_COURSE": "Modificar curso",
    "PUBLISH_COURSE": "Publicar curso",
    "ERROR_OCCURRED": "Ha ocurrido un error",
    "HOURS": "horas"
  },
  "contentsMain": {
    "CONTENTS": "Contenidos",
    "MASTER_COURSES": "Cursos Maestros",
    "RESOURCES": "Recursos"
  },
  "mastercourses": {
    "MASTER_COURSES": "Cursos Maestros",
    "STATUS": "Estado",
    "SEARCH_PLACEHOLDER": "Buscar ...",
    "TEMPLATE_NAME": "NOMBRE DE LA PLANTILLA",
    "CREATION_DATE": "CREACIÓN",
    "AUTHOR": "AUTOR",
    "NO_RESULTS": "No hay resultados para mostrar...",
    "PREVIOUS": "Anterior",
    "NEXT": "Siguiente",
    "PAGE": "Página",
    "MAKE_A_COPY": "Hacer una copia",
    "PUBLISH": "Publicar",
    "DISABLE": "Deshabilitar",
    "ENABLE": "Habilitar",
    "ERROR_LOADING_DATA": "Ha ocurrido un error cargando los datos"
  },
  "moduleEditor": {
    "STUDENT_PRACTICE": "Práctica con estudiantes",
    "PRACTICE_TYPE": "Tipo de práctica",
    "PRACTICE_TYPE_TRIP": "TRIP",
    "PRACTICE_TYPE_SITUATED_PRACTICE": "Práctica situada",
    "CONFIGURATION": "Configuración",
    "CONFIRM_DELETE_CONTENT": "¿Deseas eliminar el contenido?",
    "DELETE_WARNING": "Una vez eliminado, no se podrá recuperar.",
    "ERROR_DELETING_CONTENT": "Error al intentar eliminar contenido"
  }  
}
